import * as Yup from 'yup'



export const validationSchemas = (isRegistraHito, pagoTotal, pagoCuotas, maxNroCuotas, medioPagoPie, montoRecobro) => {

  //console.log("is pagoTotal:", pagoTotal);
  //console.log("is pagoCuotas:", pagoCuotas);
   
  let validationObject = { };

  validationObject["codHito"] = Yup.string().required('Campo obligatorio.');
  validationObject["fechaOcurrencia"] = Yup.date().required('Campo obligatorio.');

  if (pagoTotal) {

      validationObject["medioPago"] = Yup.date().required('Campo obligatorio.');
      validationObject["banco"] = Yup.string().required('Campo obligatorio.');
      //validationObject["nroChequeTrx"] = Yup.string().required('Campo obligatorio.');
      validationObject["fechaTransaccion"] = Yup.date().required('Campo obligatorio.');

      validationObject["montoRendirPie"] = Yup.string().required('Campo obligatorio.').test(
        "len",
        "Debe ser un número mayor o igual a 0",
        (val) => {
          if (val === undefined || val === "") {
            return false;  // Si el campo está vacío, el valor es inválido.
          }
          const parsedValue = parseFloat(val); //parseFloat(val.replace(/\./g, ''));// Elimina puntos y convierte el valor a número
          return !isNaN(parsedValue) && parsedValue >= 0;
        }
      );
      validationObject.fileComprobante = Yup
      .mixed()
      .required('Debe adjuntar Comprobante.')
      .test('fileSize', 'Tamaño máximo del archivo 5MB.',
        (value) => {
            if (!value) return true;
            return value.size <= (5 * 1000000);
        })
   }
   if (pagoCuotas) {
    
      validationObject["medioPago"] = Yup.string().required('Campo obligatorio.');
      //validationObject["covenioPagoCuota"] = Yup.string().required('Convenio Pago obligatorio.');
      //validationObject["cntCuotas"] = Yup.string().required('Cnt. Cuotas obligatoria.');
      validationObject["diaPago"] = Yup.string().required('Campo obligatorio.');
      validationObject["fechaPrimerPago"] = Yup.date().required('Campo obligatorio.');
      //validationObject["fechaUltimoPago"] = Yup.date().required('Fecha Último Pago obligatoria.');
      validationObject["cntCuotas"] = Yup.number('Debe ser número').required('Campo obligatorio.').min(2, "Cnt. Cuotas debe ser mayor a 2").max(maxNroCuotas,"Cnt. Cuotas no puede ser mayor a " + maxNroCuotas);
   }
   if (medioPagoPie) {
      validationObject["banco"] = Yup.string().required('Campo obligatorio.');
      //validationObject["nroChequeTrx"] = Yup.string().required('Campo obligatorio.');
      validationObject["montoPagoPie"] = Yup.string().required('Campo obligatorio.').test(
        "len",
        "Positivo y menor a monto recobro",
        (val) => {
          if (val === undefined) {
            return true;
          }
          return parseInt(val) <= montoRecobro;
          //return parseInt(val.replace(/\./g, '')) > -1 && parseInt(val.replace(/\./g, '')) <= montoRecobro;
        }
      );
      validationObject["fechaPagoPie"] = Yup.date().required('Campo obligatorio.');

      /*validationObject["montoRendirPie"] = Yup
      .number()
      .nullable()
      .test(
        "montos-iguales-si-hay-montoRendirPie",
        "Debe ser igual a Monto Pago (pie).",
        function () {
          const { montoPagoPie, montoRendirPie } = this.parent;
          
          const clean = (val) => Number((val || '').toString().replace(/\./g, '').replace(',', '.'));

          if (clean(montoPagoPie) > 0) {
            console.log("montoRendirPie:", clean(montoRendirPie));
            console.log("montoPagoPie:", clean(montoPagoPie));
            return clean(montoRendirPie) === clean(montoPagoPie);
          }
          return true; 
        }
      )*/
      
      validationObject.fileComprobante = Yup
      .mixed()
      .when("montoPagoPie", {
        is: (value) => value > 0,
        then: (schema) => schema.required("Debe adjuntar Comprobante."),
        otherwise: (schema) => schema.notRequired()
       })
      .test('fileSize', 'Tamaño máximo del archivo 5MB.',
        (value) => {
            if (!value) return true;
            return value.size <= (5 * 1000000);
      })
   }
  validationObject["minutaHito"] = Yup.string().test(
    "len",
    "No puede exeder 1000 caracteres..",
    (val) => {
      if (val === undefined) {
        return true;
      }
      return val.length === 0 || (val.length >= 0 && val.length <= 1000);
    }
  );
  return Yup.object().shape(validationObject);
}

